(function (DM) {
    'use strict';

    DM.Utils.prolongCookie('traffic_source', 30);
    DM.Utils.prolongCookie('dm_visit_id', 30);
    DM.Utils.prolongCookie('CampaignSource',30);

})(window.DM);
